module.exports = __webpack_public_path__ + "img/acasia-icon.1a4ddffa.png";